// extracted by mini-css-extract-plugin
module.exports = {"bannerStatic":"BannerStatic_bannerStatic__j6rtB"};